import { render, staticRenderFns } from "./home_coupon.vue?vue&type=template&id=4e1a9066&scoped=true"
import script from "./home_coupon.vue?vue&type=script&lang=js"
export * from "./home_coupon.vue?vue&type=script&lang=js"
import style0 from "./home_coupon.vue?vue&type=style&index=0&id=4e1a9066&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1a9066",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e1a9066')) {
      api.createRecord('4e1a9066', component.options)
    } else {
      api.reload('4e1a9066', component.options)
    }
    module.hot.accept("./home_coupon.vue?vue&type=template&id=4e1a9066&scoped=true", function () {
      api.rerender('4e1a9066', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/home_coupon.vue"
export default component.exports